<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Subject Head</th>
                        <th>Selection Type</th>
                        <th>Subject Rule</th>
                        <th>Credits</th>
                        <th>Bucket No</th>
                        <th>Pick-Up Count</th>
                        <th>Subject / Group</th>
                    </tr>
                </thead>

                <tbody>
                   <tr v-for="(item, index) in finalList" :key="index">
                        <td>{{ item.sr_no }}</td>
                        <td>{{ item.subject_head }}</td>
                        <td>{{ item.selection_type }}</td>
                        <td>{{ item.subject_rule }}</td>
                        <td>{{ item.credits }}</td>
                        <td>{{ item.bucket_no }}</td>
                        <td>{{ item.pickup_count }}</td>

                        <td width="350">
                            <div v-if="subjectSelectionDone">
                                <div v-if="item.subject_rule === 'CP'">
                                    <div v-for="(sub, subIdx) in item.subjects" :key="'cp_' + subIdx">
                                        <strong>{{ sub.subject_code }} : {{ sub.subject_name }}</strong>
                                    </div>
                                </div>

                                <div v-else-if="item.is_group">
                                    <div v-for="grp in getSelectedGroups(item)" :key="grp.tdsg_id || grp.subject_group_id" class="mb-2">
                                        <v-chip color="blue lighten-5" label small class="mb-1">
                                            <strong>{{ grp.subject_name }}</strong>
                                        </v-chip>
                                        <div v-for="(sub, i) in grp.group_subjects" :key="i" class="ml-4 caption grey--text text--darken-2">
                                            {{ sub.subject_code }} : {{ sub.subject_name }}
                                        </div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div v-for="sub in getSelectedSubjects(item)" :key="sub.course_offering_id">
                                        <strong>{{ sub.subject_code }} : {{ sub.subject_name }}</strong>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <div v-if="item.subject_rule === 'CP'">
                                    <div v-for="(sub, subIdx) in item.subjects" :key="'cp_edit_' + subIdx">
                                        <strong>{{ sub.subject_code }} : {{ sub.subject_name }}</strong>
                                    </div>
                                </div>

                                <v-select
                                    v-else
                                    :items="formattedItems(item)"
                                    item-text="display_name"
                                    :item-value="item.is_group ? 'tdsg_id' : 'course_offering_id'"
                                    v-model="item.selected_course_offering_id"
                                    :multiple="item.pickup_count > 1"
                                    dense outlined clearable deletable-chips small-chips
                                    :menu-props="{ closeOnContentClick: false }"
                                >
                                    <template v-slot:selection="data">
                                        <v-chip small close @click:close="removeSelection(item, data.item)">
                                            {{ data.item.display_name }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:item="{ item: option }">
                                        <v-list-item @click.stop="toggleSelection(item, option)">
                                            <v-list-item-action>
                                                <v-checkbox :input-value="isSelected(item, option)" readonly></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <div v-if="item.is_group">
                                                    <span class="font-weight-bold">{{ option.subject_name }} : </span>
                                                    <span class="caption">
                                                        {{ option.group_subjects.map(sub => sub.subject_name).join(', ') }}
                                                    </span>
                                                </div>
                                                <div v-else>{{ option.display_name }}</div>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-select>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="8" class="text-center">
                            <v-btn color="primary" class="mt-4" @click="confirmDialog = true" :disabled="subjectSelectionDone">
                                {{ subjectSelectionDone ? 'Registration Completed' : 'Save Subjects' }}
                            </v-btn>
                        </td>
                    </tr>
                </tfoot>
            </template>
        </v-simple-table>

        <v-dialog v-model="confirmDialog" max-width="500">
            <v-card class="confirm-dialog-card">
                <v-card-title class="headline confirm-dialog-title">Confirm Subject Selection</v-card-title>
                <v-card-text>
                    Are you sure you want to submit your subjects/groups registration?<br><br>
                    Once submitted, you will NOT be able to edit or save again.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="grey" @click="confirmDialog = false">Cancel</v-btn>
                    <v-btn color="primary" @click="confirmSaveSubjects">Confirm & Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            finalList: [],
            application_form_data: {
                admission_form_no: "",
                admission_form_id: "",
            },
            subjectSelectionDone: false,
            confirmDialog: false,
        };
    },
    methods: {
        getSubjects() {
            this.loader = true;
            axios.post("/admissionForm/subjectDetails", this.application_form_data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.subjectSelectionDone = res.data.subjectSelectionDone;
                        this.finalList = res.data.finalList.map(item => {
                            let selection = item.selected_course_offering_id;
                            if (selection == null) {
                                selection = item.pickup_count > 1 ? [] : null;
                            }
                            return { ...item, subjects: item.subjects || [], selected_course_offering_id: selection };
                        });
                        this.$store.commit("setform_progress", res.data.form_progress);
                    }
                })
                .finally(() => { this.loader = false; });
        },

        confirmSaveSubjects() {
            for (const item of this.finalList) {
                if (item.subject_rule === "CP") continue;
                if (item.is_optional === false && item.subjects && item.subjects.length > 0) {
                    const selection = item.selected_course_offering_id;
                    let count = Array.isArray(selection) ? selection.length : (selection ? 1 : 0);
                    if (count < item.pickup_count) {
                        this.showSnackbar("error", `Please select ${item.pickup_count} for ${item.subject_head}.`);
                        return;
                    }
                }
            }

            this.confirmDialog = false;
            this.loader = true;

            let selectedGroups = [];
            let selectedSingles = [];

            this.finalList.forEach(item => {
                if (item.subject_rule === "CP") {
                    item.subjects.forEach(sub => {
                        if (sub.course_offering_id) selectedSingles.push(sub.course_offering_id);
                    });
                    return;
                }

                let selected = item.selected_course_offering_id;
                if (!selected) return;

                let selectedArray = Array.isArray(selected) ? selected : [selected];

                if (item.is_group) {
                    selectedArray.forEach(id => {
                        if (id) {
                            selectedGroups.push({ group_id: id }); 
                        }
                    });
                } else {
                    selectedArray.forEach(id => {
                        if (id) selectedSingles.push(id);
                    });
                }
            });

            let payload = {
                admission_form_id: this.application_form_data.admission_form_id,
                selectedGroups: selectedGroups,
                selectedSingles: [...new Set(selectedSingles)] 
            };

            axios.post("/admissionForm/saveSelectedSubjects", payload)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.showSnackbar("success", "Subjects Saved Successfully");
                        this.getSubjects();
                    } else {
                        this.showSnackbar("error", res.data.message || "Capacity Full");
                    }
                })
                .catch(() => { this.showSnackbar("error", "Server Error"); })
                .finally(() => { this.loader = false; });
        },

        formattedItems(item) {
            return (item.subjects || []).map(s => ({
                ...s,
                display_name: item.is_group ? s.subject_name : `${s.subject_code} : ${s.subject_name}`
            }));
        },

        isSelected(item, option) {
            const value = item.is_group ? (option.tdsg_id || option.subject_group_id) : option.course_offering_id;
            const selected = item.selected_course_offering_id;
            return Array.isArray(selected) ? selected.includes(value) : selected === value;
        },

        toggleSelection(item, option) {
            const value = item.is_group ? option.tdsg_id : option.course_offering_id;
            
            if (item.pickup_count > 1) {
                if (!Array.isArray(item.selected_course_offering_id)) {
                    this.$set(item, "selected_course_offering_id", []);
                }
                const selected = [...item.selected_course_offering_id];
                const index = selected.indexOf(value);
                if (index > -1) {
                    selected.splice(index, 1);
                } else {
                    if (selected.length >= item.pickup_count) {
                        this.showSnackbar("error", `Max ${item.pickup_count} allowed`);
                        return;
                    }
                    selected.push(value);
                }
                this.$set(item, "selected_course_offering_id", selected);
            } else {
                this.$set(item, "selected_course_offering_id", 
                    item.selected_course_offering_id === value ? null : value
                );
            }
        },

        removeSelection(item, option) {
            const value = item.is_group ? (option.tdsg_id || option.subject_group_id) : option.course_offering_id;
            if (Array.isArray(item.selected_course_offering_id)) {
                item.selected_course_offering_id = item.selected_course_offering_id.filter(v => v !== value);
            } else {
                item.selected_course_offering_id = null;
            }
        },

        getSelectedGroups(item) {
            let selected = item.selected_course_offering_id;
            if (!selected) return [];
            let selectedArray = Array.isArray(selected) ? selected : [selected];
            return item.subjects.filter(g => selectedArray.includes(g.tdsg_id || g.subject_group_id));
        },

        getSelectedSubjects(item) {
            let selected = item.selected_course_offering_id;
            if (!selected) return [];
            let selectedArray = Array.isArray(selected) ? selected : [selected];
            return item.subjects.filter(s => selectedArray.includes(s.course_offering_id));
        },

        showSnackbar(color, msg) {
            this.snackbar = true;
            this.color = color === 'success' ? 'green' : 'red';
            this.snackbar_msg = msg;
        }
    },
    mounted() {
        this.application_form_data = this.$store.getters.application_form_data;
        this.getSubjects();
    }
};
</script>

<style scoped>
.confirm-dialog-card { border-radius: 16px; overflow: hidden; }
.confirm-dialog-title { background: #ffebee; color: #c62828; padding: 18px 24px; font-size: 22px; font-weight: 700; border-bottom: 1px solid #ffcdd2; }
.confirm-dialog-card .v-card__text { padding: 28px 24px 16px; font-size: 16px; line-height: 1.7; color: #424242; }
.confirm-dialog-card .v-card__actions { padding: 16px 24px 24px; }
.confirm-dialog-card .v-btn { text-transform: none; font-weight: 600; letter-spacing: 0; border-radius: 8px; }
.headline { color: red; }
</style>